<!--
    Dumb component that renders filters based on the config in use and sends event
    to the primary node state inside the same context wrapper
-->


<script>

    import FiltersMixin from "author/pagesbuilder/mixins/FiltersMixin";

    export default {
        name: "FiltersComponent",
        mixins: [
            FiltersMixin
        ],
        data () {
            return {
                componentType: "filters",
                rendersWithVue: true,
                primaryNodeTypes : {
                    "course-cards" : "course-cards-filters",
                    "bundle-cards" : "bundle-cards-filters",
                    "subscription-cards" : "subscription-cards-filters",
                    "blog-post-cards" : "blog-post-cards-filters"
                }
            }
        },
        computed : {
            availableFilters () {
                return [
                    {
                        cardFilename : "CourseCardFilters1",
                        forSectionTemplate: "Courses1",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/coursecard1.jpg"
                    },
                    {
                        cardFilename : "CourseCardFilters1",
                        forSectionTemplate: "Courses2",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/coursecard2.jpg"
                    },
                    {
                        cardFilename : "CourseCardFilters1",
                        forSectionTemplate: "Courses3",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/coursecard3.jpg"
                    },
                    {
                        cardFilename : "CourseCardFilters1",
                        forSectionTemplate: "Courses4",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/coursecard4.jpg"
                    },
                    {
                        cardFilename : "CourseCardFilters1",
                        forSectionTemplate: "Courses5",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/coursecard5.jpg"
                    },
                    {
                        cardFilename : "CourseCardFilters1",
                        forSectionTemplate: "Courses6",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/coursecard6.jpg"
                    },
                ]
            },

            getDefaultDataStructure () {
                return {
                    componentType: this.componentType,
                    componentId: this.componentId,
                    styles: null,
                    disabledFilters: [],
                    template: this.getDefaultFilterTemplate,
                    itemVisibilitySettings: null
                }
            },
            getDefaultFilterTemplate () {
                let sectionState = this.findNodeState(this.sectionId);
                let sectionTemplateId = sectionState.sectionTemplateId;
                let cardTypeData = this.availableFilters.find(cardData => sectionTemplateId === cardData.forSectionTemplate);

                if (sectionState && cardTypeData) {
                    return cardTypeData.cardFilename;
                }

                return this.availableFilters[0] ? this.availableFilters[0].cardFilename : "";
            },
            contextWrapper () {
                return this.hasContext("context-wrapper") ? this.findNodeState(this.hasContext("context-wrapper")[0].id) : null;
            },
            getPrimaryNodeState () {
                return this.contextWrapper && this.contextWrapper.getPrimaryNodeState ? this.contextWrapper.getPrimaryNodeState : null ;
            },
            getFiltersConfig () {
                return this.getPrimaryNodeState && this.getPrimaryNodeState.getFiltersConfig ? this.getPrimaryNodeState.getFiltersConfig : null ;
            },
            getFiltersParams () {
                return this.getPrimaryNodeState && this.getPrimaryNodeState.getFiltersParams ? this.getPrimaryNodeState.getFiltersParams : {};
            },
            filtersType () {
                return this.getPrimaryNodeState && this.primaryNodeTypes[this.getPrimaryNodeState.myNodeType] ? this.primaryNodeTypes[this.getPrimaryNodeState.myNodeType] : "";
            },
        },
        methods : {
            primaryFilterApplied (data) {
                if (this.getPrimaryNodeState) {
                    this.getPrimaryNodeState.setPrimaryFilter({value:data});
                }
            },
            secondaryFilterApplied (data) {
                if (this.getPrimaryNodeState) {
                    this.getPrimaryNodeState.setPrimaryFilter({value: data.primaryKey});
                    this.getPrimaryNodeState.setSecondaryFilter({value: data.secondaryKey});
                }
            }
        }
    }
</script>

